// Review.jsx
import React, { useState } from "react";
import Navbar from "../../components/navigation/web/Navbar";
import { useTranslation } from "react-i18next";
import { ModuleReview } from "../../components/Review/ModuleReview";

const Review = () => {
	const { t } = useTranslation();

	// Estados para manejar el contenido y título que se verán en la barra lateral
	const [rightTitle, setRightTitle] = useState("");
	const [rightComponent, setRightComponent] = useState(null);

	return (
		<>
			<Navbar
				view={{
					title: t("review.title"),
					// Le pasamos funciones a ModuleReview para que, cuando haga clic,
					// sepa qué título y qué contenido poner en la barra lateral.
					component: (
						<ModuleReview setRightTitle={setRightTitle} setRightComponent={setRightComponent} />
					),
				}}
				right={
					rightComponent // Si existe contenido, se muestra la barra
						? {
								title: rightTitle,
								component: rightComponent,
						  }
						: null // Si no hay contenido, no se renderiza nada en la derecha
				}
			/>
		</>
	);
};

export { Review };
